<template>
  <v-row>
    <v-col cols="12">

      <!-- fast state -->
      <v-card>
        <v-tabs background-color="background" color="primary" grow height="55" slider-size="4">
          <v-tab class="text-none font-weight-medium" to="/receivables/agreements" exact>Todos</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/receivables/agreements?status=active" exact>Vigentes</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" :to="`/receivables/agreements?status=active&date__lte=${today}`" exact>Vencidos</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/receivables/agreements?invoice__status=paid" exact>Cumplidos</v-tab>
        </v-tabs>
      </v-card>
      <!-- end fast state -->

      <v-card class="px-0 mt-5">
        <v-skeleton-loader v-if="$store.state.receivables.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Acuerdos</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="agreement" class="mr-1" />
              <v-btn @click="dialogCreate=true" outlined color="secondary"><v-icon left small>mdi-plus</v-icon>Nuevo</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <agreement-list :show-create="true" @create="dialogCreate=true" @change="getList" />
        </v-card-text>
      </v-card>

      <agreement-create-dialog v-model="dialogCreate" @created="getList" />

    </v-col>
  </v-row>
</template>
<script>
import { agreementFilters } from '@/collections/queryBuilderFilters'

import AgreementCreateDialog from '@/components/receivables/AgreementCreateDialog'
import AgreementList from '@/components/receivables/AgreementList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'

import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    AgreementCreateDialog,
    AgreementList,
    VQueryBuilder
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    filters: agreementFilters
  }),
  methods: {
    getList () {
      this.$store.dispatch('receivables/LIST', {
        resource: 'agreements',
        query: this.$route.query
      })
    }
  }
}
</script>
